export enum HrDocumentSelectField {
    login = "hr_login",
    business_group = "hr_business_group_name",
    qualification = "hr_qualification_name",
    military = "hr_military_doc",
    assignment = "hr_assignment_number",
    loan = "hr_loan_number",
    subpoena = "subpoena_receipt_date",
    contact = "hr_contact_full_name",
    account = "hr_account_bank_name"
}
